import React from 'react';
import { EmptyAddress } from './styles/locationAddress.styles';

export const NoAddress = ({ secondary }) => {
  return (
    <EmptyAddress noAddress secondary={secondary}>
      Address Not Found
    </EmptyAddress>
  );
};
